import { useState, useEffect } from 'react';
import { getCutoffTime } from '../services/dateUtils';

export const useLockStatus = (selectedDeliveryDate) => {
    const [isLocked, setIsLocked] = useState(false);

    useEffect(() => {
        const checkLockStatus = () => {
            if (!selectedDeliveryDate) {
                setIsLocked(false);
                return;
            }
            const now = new Date();
            const lockDate = getCutoffTime(selectedDeliveryDate);
            if (!lockDate) {
                setIsLocked(false);
                return;
            }
            const shouldLock = now >= new Date(lockDate.getTime() + 1000 * 60 * 60); // leniency 1 hour
            setIsLocked(shouldLock);
        };

        checkLockStatus();
    }, [selectedDeliveryDate]);

    return isLocked;
};